import './App.css';
import React, { useState } from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import Login from './Login';
import ProductList from './ProductList';
import FileUpload from './FileUpload';

function App() {
    const [authToken, setAuthToken] = useState('');

    return (
        <Router>
            <div>
                <Routes>
                    <Route path="/login" element={<Login setAuthToken={setAuthToken} />} />
                    <Route
                        path="/products"
                        element={authToken ? <ProductList authToken={authToken} /> : <Navigate to="/login" />}
                    />
                    <Route
                        path="/upload"
                        element={authToken ? <FileUpload authToken={authToken} /> : <Navigate to="/login" />}
                    />
                    <Route path="/" element={<Navigate to="/login" />} />
                </Routes>
            </div>
        </Router>
    );
}

export default App;